import React, { useState } from "react";
import { toast } from "sonner";
import { MapPin, Phone, Mail, MessageSquare } from "lucide-react";
import { CONTACT } from "@/data/constants";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/context/I18nContext";

export default function Contact() {
  const { t } = useI18n();
  const [f, setF] = useState({ name: "", phone: "", email: "", subject: "", message: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !/^\d{10}$/.test(f.phone)) return toast.error("Enter valid name & 10-digit mobile");
    try { await api.post("/enquiries", f); toast.success("Enquiry sent — we'll contact you soon."); setF({ name: "", phone: "", email: "", subject: "", message: "" }); }
    catch { toast.error("Failed to send"); }
  };
  return (
    <div className="max-w-[1400px] mx-auto px-4 py-8">
      <div className="text-center max-w-2xl mx-auto">
        <h1 className="font-display text-4xl font-bold text-slate-900">{t("contact.title")}</h1>
        <p className="text-slate-600 mt-2">{t("contact.sub")}</p>
      </div>
      <div className="mt-10 grid lg:grid-cols-[1fr,1.5fr] gap-8">
        <div className="space-y-4">
          <div className="bg-white border border-slate-200 rounded-2xl p-6">
            <MapPin className="text-kp-maroon" size={22}/>
            <h3 className="font-display font-semibold mt-3">Our Office</h3>
            <p className="text-sm text-slate-600 mt-1">{CONTACT.address}</p>
          </div>
          <a href={`tel:${CONTACT.phoneRaw}`} className="block bg-white border border-slate-200 rounded-2xl p-6 hover:border-kp-teal card-hover">
            <Phone className="text-kp-teal" size={22}/>
            <h3 className="font-display font-semibold mt-3">{t("contact.call")}</h3>
            <p className="text-sm text-slate-600 mt-1">{CONTACT.phone}</p>
          </a>
          <a href={CONTACT.whatsappUrl} target="_blank" rel="noreferrer" className="block bg-white border border-slate-200 rounded-2xl p-6 hover:border-kp-maroon card-hover">
            <MessageSquare className="text-kp-maroon" size={22}/>
            <h3 className="font-display font-semibold mt-3">{t("contact.wa")}</h3>
            <p className="text-sm text-slate-600 mt-1">{CONTACT.phone}</p>
          </a>
          <a href={`mailto:${CONTACT.email}`} className="block bg-white border border-slate-200 rounded-2xl p-6 hover:border-kp-teal card-hover">
            <Mail className="text-kp-teal" size={22}/>
            <h3 className="font-display font-semibold mt-3">Email Us</h3>
            <p className="text-sm text-slate-600 mt-1">{CONTACT.email}</p>
          </a>
        </div>
        <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-6 space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="text-xs font-semibold text-slate-600">{t("contact.name")} *</label><Input required value={f.name} onChange={(e) => setF({...f, name: e.target.value})} data-testid="contact-name"/></div>
            <div><label className="text-xs font-semibold text-slate-600">{t("contact.phone")} *</label><Input required value={f.phone} onChange={(e) => setF({...f, phone: e.target.value.replace(/\D/g,"")})} maxLength={10} data-testid="contact-phone"/></div>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="text-xs font-semibold text-slate-600">{t("contact.email")}</label><Input type="email" value={f.email} onChange={(e) => setF({...f, email: e.target.value})}/></div>
            <div><label className="text-xs font-semibold text-slate-600">{t("contact.subject")}</label><Input value={f.subject} onChange={(e) => setF({...f, subject: e.target.value})}/></div>
          </div>
          <div><label className="text-xs font-semibold text-slate-600">{t("contact.message")}</label><Textarea rows={5} value={f.message} onChange={(e) => setF({...f, message: e.target.value})} data-testid="contact-message"/></div>
          <Button type="submit" className="btn-primary rounded-full h-12 px-8 font-semibold" data-testid="btn-send-enquiry">{t("contact.send")}</Button>
        </form>
      </div>
    </div>
  );
}
